const LOCATION_TIMEOUT_MS = 15000;

export const currentPosition = () =>
  new Promise((resolve) => {
    if (!navigator.geolocation) {
      resolve({ error: "unavailable" });
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) =>
        resolve({
          point: { latitude: position.coords.latitude, longitude: position.coords.longitude },
          accuracy: position.coords.accuracy,
        }),
      (error) => resolve({ error: error.code === 1 ? "permission" : "unavailable" }),
      { enableHighAccuracy: true, timeout: LOCATION_TIMEOUT_MS, maximumAge: 0 }
    );
  });
